import { toast } from "react-toastify";
import io from "socket.io-client";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "../features/admin/NotificationSlice";

const ToastNotification = () => {
  const userId = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("access_token_bccu");
  const dispatch = useDispatch();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!accessToken) return;

    const newSocket = io(process.env.REACT_APP_API_URL, {
      query: { token: accessToken },
    });

    setSocket(newSocket);

    const handleNewPost = (response) => {
      toast.success(response.content, { autoClose: 5000, type: "info" });
      if (userId) {
        dispatch(fetchNotifications(userId));
      }
    };

    newSocket.on("new_post", handleNewPost);

    return () => {
      newSocket.off("new_post", handleNewPost);
      newSocket.close();
    };
  }, [accessToken]);

  return null;
};

export default ToastNotification;
